import { __awaiter as c, __generator as h } from "./index11.js";
import { fetch as b } from "./index32.js";
import { onPageLeave as g } from "./index75.js";
var w = 500;
function d(i) {
  var t = encodeURI(JSON.stringify(i)).split(/%..|./).length - 1;
  return t / 1024;
}
function k(i) {
  return d(i) >= w - 50;
}
function A(i) {
  var t = [], e = 0;
  return i.forEach(function(o) {
    var r = d(t[e]);
    r >= 64 && e++, t[e] ? t[e].push(o) : t[e] = [o];
  }), t;
}
function I(i, t) {
  var e, o, r = [], l = !1, p = (e = t?.size) !== null && e !== void 0 ? e : 10, m = (o = t?.timeout) !== null && o !== void 0 ? o : 5e3;
  function s(n) {
    var u;
    if (n.length !== 0) {
      var a = (u = n[0]) === null || u === void 0 ? void 0 : u.writeKey;
      return b("https://".concat(i, "/b"), {
        keepalive: l,
        headers: {
          "Content-Type": "text/plain"
        },
        method: "post",
        body: JSON.stringify({ batch: n, writeKey: a })
      });
    }
  }
  function v() {
    return c(this, void 0, void 0, function() {
      var n;
      return h(this, function(u) {
        return r.length ? (n = r, r = [], [2, s(n)]) : [
          2
          /*return*/
        ];
      });
    });
  }
  var f;
  function _() {
    f || (f = setTimeout(function() {
      f = void 0, v().catch(console.error);
    }, m));
  }
  g(function() {
    if (l = !0, r.length) {
      var n = A(r).map(s);
      Promise.all(n).catch(console.error);
    }
  });
  function y(n, u) {
    return c(this, void 0, void 0, function() {
      var a;
      return h(this, function(O) {
        return r.push(u), a = r.length >= p || k(r), [2, a || l ? v() : _()];
      });
    });
  }
  return {
    dispatch: y
  };
}
export {
  I as default
};
//# sourceMappingURL=index52.js.map
